import { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CardHeader from '@mui/material/CardHeader';
import {Button,Typography,Box} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
//import StrategyModalView from '../Modals/StrategyModal/StrategyModal_View'
import StrategyViewDialog from '../../components/Modals/StrategyModal/StrategyModal_View'
import { UserContext } from '../../context/UserContext'
import Iconify from '../../common/Iconify/Iconify';
import ErrorMessage from '../../common/ErrorMessage/ErrorMessage'
import BarChartModalView from '../../components/Modals/BarchartModal/BarchartModal_View'

// ----------------------------------------------------------------------
//export default function StrategiesList({ title, subheader, list, ...others }) {

export default function StrategiesList({ title, subheader, list, id_client }) {
  
  const [selected, setSelected] = useState(['2']);

  const handleClickComplete = (taskId) => {
    const tasksCompleted = selected.includes(taskId)
      ? selected.filter((value) => value !== taskId)
      : [...selected, taskId];

    setSelected(tasksCompleted);
  };

  return (
    <Card
    sx={{
      '& .MuiStack-root': {backgroundColor: '#231E39', color: 'gray', fontStyle:'oblique', fontSize:'11px'},
      '& .MuiBox-root' : {backgroundColor: '#231E39'},
      '& .MuiCardHeader-root' : {color: 'white'},
      '& .MuiButton-text' : {color: 'var(--main-color)'},
      '& .MuiIconButton-root' : {color: 'white'},
     
      }} 
    >
      <Box
          sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 0,  // Adjust padding as needed
        }}
        
      >
        <CardHeader title={title} subheader={subheader} />
      </Box>

      {list.map((commitment) => (
        
        <TaskItem
          key={commitment.ID_Strategy}
          task={commitment}
          id_client = {id_client}
          checked={selected.includes(commitment.ID_Strategy)}
          onChange={() => handleClickComplete(commitment.ID_Strategy)}
          
        />
      ))}
      
    </Card>
  );
}

StrategiesList.propTypes = {
  list: PropTypes.array,
  subheader: PropTypes.string,
  title: PropTypes.string,
};

// ----------------------------------------------------------------------

function TaskItem({ key, task, id_client,checked,onChange }) {

  const [open, setOpen] = useState(null);
  const [viewopen, setViewOpen] = useState(null);
  const [viewopenprogress,setViewOpenProgress] = useState(null);
  const [login, setLogin] = useContext(UserContext);
  const isLoggedIn = login.isLoggedIn
  const [activeModal, setActiveModal] = useState(false);
  const [idstrategy, setIdStrategy] = useState(null);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    
  };

  const handleCloseStrategyView = () => {
    setViewOpen(false);
    handleCloseMenu()
  };

  const handleOpenView = async (e,idstrategy) => {
    e.stopPropagation();
    setIdStrategy(idstrategy);
    setViewOpen(true);
    console.log('activeModal', viewopen);
  }

  const handleOpenProgress = async (e,idstrategy) => {
    e.stopPropagation();
    setIdStrategy(idstrategy);
    setViewOpenProgress(true);
    console.log('activeModal', viewopen);
  }

  const handleCloseProgressView = () => {
    setViewOpenProgress(false);
    handleCloseMenu()
  }

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          pl: 2,
          pr: 1,
          py: 1,
          '&:not(:last-of-type)': {
            borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
          },
        }}
      >
       
        <Typography
          //onClick={handleEdit} // Add click handler here
          sx={{ flexGrow: 1, m: 0, cursor: 'pointer' }}
        >
          {task.Desc_Strategy}
        </Typography>

        <IconButton color={open ? 'inherit' : 'default'} onClick={handleOpenMenu}>
          <Iconify icon="eva:more-vertical-fill" />
        </IconButton>
      </Stack>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
      
        <MenuItem onClick={(e) => handleOpenView(e,task.ID_Strategy)}>       
          <Iconify icon="carbon:view-filled" sx={{ mr: 2 }} />
          View details
        </MenuItem>
        <MenuItem onClick={(e) => handleOpenProgress(e,task.ID_Strategy)}>       
          <Iconify icon="bi:bar-chart-line-fill" sx={{ mr: 2 }} />
          View Progress
        </MenuItem>

        <StrategyViewDialog open={viewopen} handleClose={handleCloseStrategyView} id_client={id_client} id_strategy={idstrategy} />
        <BarChartModalView 
          open={viewopenprogress} 
          handleClose={handleCloseProgressView} 
          id_client={id_client} 
          id_strategy={idstrategy}
          desc_strategy={task.Desc_Strategy}
          size = "lg" /> 

      </Popover>
    </>
  );
}

TaskItem.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  task: PropTypes.object,
};